import React from "react";
import Feature from "../../components/feature/Feature";
import "./githubstats.css";

const GithubStats = ({ githubUsername }) => {
  console.log(123);
  return (
    <div className="portfolioX__portfolioX section__margin rounded" id="wgpt3">
      <div className="portfolioX__portfolioX-feature">
        <Feature
          title="Github Stats"
          classX="text-gradient"
          text=""
        />
      </div>
      <div className="portfolioX__portfolioX-heading">
        <h1 className="gradient__text">Github summary data</h1>
      </div>
      <div className="portfolioX__portfolioX-container">
        <img width="320px" align="left" className="p-2" src={`https://github-readme-stats.vercel.app/api?username=${githubUsername}&show_icons=true&count_private=true&hide=stars&include_all_commits=false&theme=material-palenight`} />
        <img width="320px" align="center" className="p-2" src={`https://github-readme-stats.vercel.app/api/top-langs/?username=${githubUsername}&langs_count=8&layout=compact&theme=material-palenight&hide=html,Tcl`} />
        <img width="320px" align="right" className="p-2" src={`http://github-readme-streak-stats.herokuapp.com?user=${githubUsername}&theme=material-palenight`} />
        <img width="100%" align="center" className="p-2" src={`https://github-profile-trophy.vercel.app/?username=${githubUsername}&theme=dracula&no-bg=true&row=1`} />
        {/* <img width="49%" align="center" src="https://github-readme-stats.vercel.app/api/pin/?username=gabrlcj&repo=pokemonbank&theme=slateorange&bg_color=bbb8b2&title_color=f34213&text_color=0c0c0c&icon_color=0c0c0c" /> */}
      </div>
    </div>
  );
};

export default GithubStats;
